import type { RouteObject } from "react-router-dom";
import { NotFound } from "../components/not-found.components";
import { HomeAdminScreen } from "../screens/admin/home.admin.screen";
import { SocialsAdminScreen } from "../screens/admin/home/dashboard-socials.admin.screen";
import { BrandAdminScreen } from "../screens/admin/brands/brand.admin.screen";
import { CreateCampaignBrandAdminScreen } from "../screens/admin/brands/create-campaign-brand.admin.screen";
import { Slider } from "../components/movables/slider.components";
import { SocialsSliderMenuAdminScreen } from "../screens/admin/menus/socials/social-slider-menu.admin.screen";
import { Modal } from "../components/movables/modal.components";
import { RejectSocialModalAdminScreen } from "../screens/admin/menus/socials/reject-social-modal.admin.screen";
import { BrandInfoSliderMenuAdminScreen } from "../screens/admin/menus/brand/brand-info-slider-menu.admin.screen";
import { AddBrandSliderMenuAdminScreen } from "../screens/admin/menus/brand/add-brand-slider-menu.admin.screen";
import { DashboardProfileCommonScreen } from "../screens/common/dashboard/dashboard-profile.common.screen";
import { CampaignViewAdminScreen } from "../screens/admin/campaigns/campaign-view.admin.screen";
import { PostSliderMenuAdminScreen } from "../screens/admin/menus/post/post-slider-menu.admin.screen";
import { EditCampaignAdminScreen } from "../screens/admin/campaigns/edit-campaign.admin.screen";
import { CampaignDraftSubmissionsAdminScreen } from "../screens/admin/campaigns/campaign-draft-submissions.admin.screen";
import { CampaignPostSubmissionsAdminScreen } from "../screens/admin/campaigns/campaign-post-submissions.admin.screen";
import { CampaignLivePostsAdminScreen } from "../screens/admin/campaigns/campaign-live-posts.admin.screen";
import { CampaignHomeAdminScreen } from "../screens/admin/campaigns/campaign-home.admin.screen";
import { PostRejectModalAdminScreen } from "../screens/admin/menus/post/post-reject-modal.admin.screen";
import { PayoutRequestsAdminScreen } from "../screens/admin/payouts/payout-requests.admin.screen";
import { FavouritesAdminScreen } from "../screens/admin/favourites/favourites.admin.screen";
import { RejectPayoutModalAdminScreen } from "../screens/admin/menus/payout/reject-payout-modal.admin.screen";
import { ExportCampaignMetricsModalAdminScreen } from "../screens/admin/menus/campaign/export-campaign-metrics-modal.admin.screen";
import { ReleaseEarningsModalAdminScreen } from "../screens/admin/menus/campaign/release-earnings-modal.admin.screen";
import { EndCampaignModalAdminScreen } from "../screens/admin/menus/campaign/end-campaign-modal.admin.screen";
import { MetricsAdminScreen } from "../screens/admin/global-metrics/metrics.admin.screen";
import { CommunicationAdminScreen } from "../screens/admin/communication/communication.admin.screen";
import { NewCommunicationSliderMenuAdminScreen } from "../screens/admin/menus/communication/new-communication-slider-menu.admin.screen";
import { DuplicateCampaignModalAdminScreen } from "../screens/admin/menus/campaign/duplicate-campaign-modal.admin.screen";
import { NewFavoriteSliderMenuAdminScreen } from "../screens/admin/menus/favorites/new-favorite-slider-menu.admin.screen";
import { FavouriteGroupAdminScreen } from "../screens/admin/favourites/favorite-group.admin.screen";
import { CampaignPostSearchAdminScreen } from "../screens/admin/campaigns/campaign-post-search.admin.screen";
import { FixedPayoutsAdminScreen } from "../screens/admin/fixed-payouts/fixed-payouts.admin.screen";
import { FixedPayoutModalAdminScreen } from "../screens/admin/menus/fixed-payouts/fixed-payout-modal.admin.screen";
import { AddFixedPayoutSliderMenuAdminScreen } from "../screens/admin/menus/campaign/add-fixed-payouts-slider.admin.screen";
import { ImportCsvModalAdminScreen } from "../screens/admin/menus/favorites/import-csv-modal.admin.screen";
import { CsvSliderMenuAdminScreen } from "../screens/admin/menus/favorites/csv-slider-menu.admin.screen";
import { ProposalAdminScreen } from "../screens/admin/proposal/proposal.admin.screen";
import { BrandManagersSliderMenuAdminScreen } from "../screens/admin/menus/campaign/brand-mangers-slider.admin.screen";
import { AddBrandManagerModalAdminScreen } from "../screens/admin/menus/campaign/add-brand-manager-modal.admin.screen";
import { StatsSliderMenuAdminScreen } from "../screens/admin/menus/favorites/stats-slider-menu.admin.screen";
import { AddSocialModalAdminScreen } from "../screens/admin/menus/socials/add-social-modal.admin.screen";
import { WalletTransactionsBaseAdminScreen } from "../screens/admin/wallet-transactions/wallet-transactions-base.admin.screen";
import { WalletTransactionsDataAdminScreen } from "../screens/admin/wallet-transactions/wallet-transactions-data.admin.screen";
import { WalletTransactionDetailsSliderAdminScreen } from "../screens/admin/menus/wallet-transactions/wallet-transaction-details-slider.admin.screen";
import { CampaignDetailsProposalsAdminScreen } from "../screens/admin/proposal/campaign-details-proposals.admin.screen";
import { CreatorListProposalsAdminScreen } from "../screens/admin/proposal/creator-list-proposals.admin.screen";
import { CommentsAdminSliderScreen } from "../screens/admin/menus/proposals/comments-proposals-slider.admin.screen";
import { ManageFiltersAdminScreen } from "../screens/admin/menus/proposals/manage-filters-slider.admin.screen";
import ProposalsAdminScreen from "../screens/admin/proposal/proposals.admin.screen";
import { InternalCostModalScreen } from "../screens/admin/menus/proposals/internal-cost-modal.admin.screen";
import { ExternalCostModalScreen } from "../screens/admin/menus/proposals/external-cost-modal.admin.screen";
import { LinkWithDMSCampaignSliderAdminScreen } from "../screens/admin/menus/campaign/link-with-dms-campaign-slider.admin.screen";
import VendorAdminScreen from "../screens/admin/vendors/vendors.admin.screen";
import AddVendorAdminScreen from "../screens/admin/menus/vendors/add-vendor-slider.admin.screen";
import VendorDetailsAdminScreen from "../screens/admin/vendors/vendor-details.admin.screen";
import VendorOverviewAdminScreen from "../screens/admin/vendors/vendor-overview.admin.screen";
import AddPANAdminScreen from "../screens/admin/menus/vendors/add-pan-slider.admin.screen";
import AddGSTAdminScreen from "../screens/admin/menus/vendors/add-gst-slider.admin.screen";
import AddPayoutSliderAdminScreen from "../screens/admin/menus/vendors/add-payout-slider.admin.screen";
import VendorCampaignsAdminScreen from "../screens/admin/vendors/vendor-campaigns.admin.screen";
import ManageVendorCampaignPostsAdminScreen from "../screens/admin/menus/vendors/manage-vender-campaigns-posts.admin.screen";
import { UsersAdminScreen } from "../screens/admin/users/dashboard-users.admin.screen";
import { InviteAdminSliderAdminScreen } from "../screens/admin/menus/usres/invite-admin-slider.admin.screen";
import { AddBudgetInternalModalAdminScreen } from "../screens/admin/menus/campaign/add-bugdget-internal-modal.admin.screen";
import { FinalizeDMSCostModalAdminScreen } from "../screens/admin/menus/campaign/finalize-dms-cost-modal.admin.screen";
import KycApprovalsAdminScreen from "../screens/admin/kyc-approvals/kyc-approvals.admin.screen";
import {
  RejectCreatorGstKycAdminScreen,
  RejectCreatorPayoutKycAdminScreen,
} from "../screens/admin/menus/kyc/reject-kyc-modal.admin.screen";
import CarouselsAdminScreen from "../screens/admin/carousels/carousels.admin.screen";
import CreateCarouselItemAdminScreen from "../screens/admin/carousels/create-carousel-item.admin.screen";
import EditCarouselItemAdminScreen from "../screens/admin/carousels/edit-carousel-item.admin.screen";

export const adminRouter: Array<RouteObject> = [
  {
    path: "",
    element: <HomeAdminScreen />,
  },
  {
    path: "kyc-approvals",
    element: <KycApprovalsAdminScreen />,
    children: [
      {
        path: "gst/:creatorId/reject",
        element: (
          <Modal navigatePath="/admin/kyc-approvals">
            <RejectCreatorGstKycAdminScreen />
          </Modal>
        ),
      },
      {
        path: "payout/:payoutMethodId/reject",
        element: (
          <Modal navigatePath="/admin/kyc-approvals">
            <RejectCreatorPayoutKycAdminScreen />
          </Modal>
        ),
      },
    ],
  },
  {
    path: "proposals",
    element: <ProposalsAdminScreen />,
    children: [],
  },
  {
    path: "proposals/proposal",
    element: <ProposalAdminScreen />,
  },
  {
    path: "proposals/proposal",
    element: <ProposalAdminScreen />,
    children: [
      {
        path: "campaign-details",
        element: <CampaignDetailsProposalsAdminScreen />,
      },
    ],
  },

  {
    path: "proposals/proposal/:proposalId",
    element: <ProposalAdminScreen />,
    children: [
      {
        path: "campaign-details",
        element: <CampaignDetailsProposalsAdminScreen />,
      },
      {
        path: "creator-list",
        element: <CreatorListProposalsAdminScreen />,
        children: [
          {
            path: ":proposalSocialId/internal-cost",
            element: (
              <Modal navigatePath="/admin/proposals/proposal/:proposalId/creator-list">
                <InternalCostModalScreen />
              </Modal>
            ),
          },
          {
            path: ":proposalSocialId/external-cost",
            element: (
              <Modal navigatePath="/admin/proposals/proposal/:proposalId/creator-list">
                <ExternalCostModalScreen />
              </Modal>
            ),
          },
          {
            path: "comments/:proposalSocialId",
            element: (
              <Slider
                className="px-0 pb-0"
                navigatePath="/admin/proposals/proposal/:proposalId/creator-list"
              >
                <CommentsAdminSliderScreen />
              </Slider>
            ),
          },
          {
            path: "manage-filters",
            element: (
              <Slider
                className="px-0 pb-0"
                navigatePath="/admin/proposals/proposal/:proposalId/creator-list"
              >
                <ManageFiltersAdminScreen />
              </Slider>
            ),
          },
        ],
      },
    ],
  },

  {
    path: "metric",
    element: <MetricsAdminScreen />,
  },

  {
    path: "users",
    element: <UsersAdminScreen />,
    children: [
      {
        path: "invite-admin",
        element: (
          <Slider navigatePath="/admin/users">
            <InviteAdminSliderAdminScreen />
          </Slider>
        ),
      },
    ],
  },

  {
    path: "socials",
    element: <SocialsAdminScreen />,
    children: [
      {
        path: "add-new",
        element: (
          <Modal navigatePath="/admin/socials">
            <AddSocialModalAdminScreen />
          </Modal>
        ),
      },
      {
        path: ":userId",
        element: (
          <Slider navigatePath="/admin/socials">
            <SocialsSliderMenuAdminScreen />
          </Slider>
        ),
      },
      {
        path: ":userId/reject",
        element: (
          <Modal navigatePath="/admin/socials">
            <RejectSocialModalAdminScreen />
          </Modal>
        ),
      },
    ],
  },

  {
    path: "vendors",
    element: <VendorAdminScreen />,
    children: [
      {
        path: "add-new",
        element: (
          <Slider className="p-0 max-w-xl" navigatePath="/admin/vendors">
            <AddVendorAdminScreen />
          </Slider>
        ),
      },
    ],
  },

  {
    path: "vendors/:vendorId",
    element: <VendorDetailsAdminScreen />,
    children: [
      {
        path: "overview",
        element: <VendorOverviewAdminScreen />,
        children: [
          {
            path: "add-pan",
            element: (
              <Slider
                className="p-0 max-w-xl"
                navigatePath="/admin/vendors/:vendorId/overview"
              >
                <AddPANAdminScreen />
              </Slider>
            ),
          },
          {
            path: "add-gst",
            element: (
              <Slider
                className="p-0 max-w-xl"
                navigatePath="/admin/vendors/:vendorId/overview"
              >
                <AddGSTAdminScreen />
              </Slider>
            ),
          },
          {
            path: "add-payout",
            element: (
              <Slider
                className="p-0 max-w-xl"
                navigatePath="/admin/vendors/:vendorId/overview"
              >
                <AddPayoutSliderAdminScreen />
              </Slider>
            ),
          },
        ],
      },
      {
        path: "campaigns",
        element: <VendorCampaignsAdminScreen />,
        children: [
          {
            path: ":campaignId/manage-posts",
            element: (
              <Slider
                className="p-0 max-w-xl"
                navigatePath="/admin/vendors/:vendorId/campaigns"
              >
                <ManageVendorCampaignPostsAdminScreen />
              </Slider>
            ),
          },
        ],
      },
    ],
  },

  {
    path: "campaigns",
    children: [
      {
        path: ":campaignId",
        element: <CampaignViewAdminScreen />,
        children: [
          {
            path: "search",
            element: <CampaignPostSearchAdminScreen />,
            children: [
              {
                path: "profile/:userId",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/search"
                  >
                    <SocialsSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId",
                element: (
                  <Slider
                    className="max-w-lg"
                    navigatePath="/admin/campaigns/:campaignId/search"
                  >
                    <PostSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId/post-reject",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/search">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "profile/:userId",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/search"
                  >
                    <SocialsSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId/disqualify",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/search">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: ":postId/flag",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/search">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: ":postId/draft-reject",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/search">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
            ],
          },
          {
            path: "campaign-metrics",
            element: <CampaignHomeAdminScreen />,
            children: [
              {
                path: "add-budget-internal",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <AddBudgetInternalModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "export",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <ExportCampaignMetricsModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "brand-managers",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/campaign-metrics"
                  >
                    <BrandManagersSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: "add-brand-manager",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <AddBrandManagerModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "duplicate",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <DuplicateCampaignModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "end-campaign",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <EndCampaignModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "release-earnings",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <ReleaseEarningsModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "manage-fixed-payout",
                element: (
                  <Slider
                    className="max-w-3xl"
                    navigatePath="/admin/campaigns/:campaignId/campaign-metrics"
                  >
                    <AddFixedPayoutSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: "link-with-dms-campaign",
                element: (
                  <Slider
                    className="p-0"
                    navigatePath="/admin/campaigns/:campaignId/campaign-metrics"
                  >
                    <LinkWithDMSCampaignSliderAdminScreen />
                  </Slider>
                ),
              },
              {
                path: "finalize-dms-cost",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/campaign-metrics">
                    <FinalizeDMSCostModalAdminScreen />
                  </Modal>
                ),
              },
            ],
          },
          {
            path: "live-posts",
            element: <CampaignLivePostsAdminScreen />,
            children: [
              {
                path: "profile/:userId",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/live-posts"
                  >
                    <SocialsSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId/disqualify",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/live-posts">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: ":postId/flag",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/live-posts">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: ":postId",
                element: (
                  <Slider
                    className="max-w-lg"
                    navigatePath="/admin/campaigns/:campaignId/live-posts"
                  >
                    <PostSliderMenuAdminScreen />
                  </Slider>
                ),
              },
            ],
          },
          {
            path: "post-submissions",
            element: <CampaignPostSubmissionsAdminScreen />,
            children: [
              {
                path: "profile/:userId",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/post-submissions"
                  >
                    <SocialsSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId",
                element: (
                  <Slider
                    className="max-w-lg"
                    navigatePath="/admin/campaigns/:campaignId/post-submissions"
                  >
                    <PostSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId/post-reject",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/post-submissions">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
            ],
          },
          {
            path: "draft-submissions",
            element: <CampaignDraftSubmissionsAdminScreen />,
            children: [
              {
                path: "profile/:userId",
                element: (
                  <Slider
                    className=""
                    navigatePath="/admin/campaigns/:campaignId/draft-submissions"
                  >
                    <SocialsSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId",
                element: (
                  <Slider
                    className="max-w-lg"
                    navigatePath="/admin/campaigns/:campaignId/draft-submissions"
                  >
                    <PostSliderMenuAdminScreen />
                  </Slider>
                ),
              },
              {
                path: ":postId/draft-reject",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/draft-submissions">
                    <PostRejectModalAdminScreen />
                  </Modal>
                ),
              },
            ],
          },
        ],
      },
      {
        path: ":campaignId",
        children: [
          {
            path: "edit",
            element: <EditCampaignAdminScreen />,
            children: [
              {
                path: ":socialId",
                element: (
                  <Modal navigatePath="/admin/campaigns/:campaignId/edit/add-fixed-payouts">
                    <FixedPayoutModalAdminScreen />
                  </Modal>
                ),
              },
              {
                path: "add-fixed-payouts",
                element: (
                  <Slider
                    className="max-w-3xl"
                    navigatePath="/admin/campaigns/:campaignId/edit"
                  >
                    <AddFixedPayoutSliderMenuAdminScreen />
                  </Slider>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "brands",
    element: <BrandAdminScreen />,
    children: [
      {
        path: ":brandId",
        element: (
          <Slider navigatePath="/admin/brands">
            <BrandInfoSliderMenuAdminScreen />
          </Slider>
        ),
      },
      {
        path: "add-brand",
        element: (
          <Slider navigatePath="/admin/brands">
            <AddBrandSliderMenuAdminScreen />
          </Slider>
        ),
      },
    ],
  },
  {
    path: "brands/:brandId",
    children: [
      {
        path: "create-campaign",
        element: <CreateCampaignBrandAdminScreen />,
        children: [
          {
            path: ":socialId",
            element: (
              <Modal navigatePath="/admin/brands/:brandId/create-campaign/add-fixed-payouts">
                <FixedPayoutModalAdminScreen />
              </Modal>
            ),
          },
          {
            path: "add-fixed-payouts",
            element: (
              <Slider
                className="max-w-3xl"
                navigatePath="/admin/brands/:brandId/create-campaign"
              >
                <AddFixedPayoutSliderMenuAdminScreen />
              </Slider>
            ),
          },
        ],
      },
    ],
  },

  {
    path: "payouts",
    element: <PayoutRequestsAdminScreen />,
    children: [
      {
        path: ":payoutId/reject",
        element: (
          <Modal navigatePath="/admin/payouts">
            <RejectPayoutModalAdminScreen />
          </Modal>
        ),
      },
    ],
  },
  {
    path: "fixed-payouts",
    element: <FixedPayoutsAdminScreen />,
    children: [
      {
        path: ":userId",
        element: (
          <Slider navigatePath="/admin/fixed-payouts">
            <SocialsSliderMenuAdminScreen />
          </Slider>
        ),
      },
      {
        path: "edit/:userId",
        element: (
          <Modal navigatePath="/admin/fixed-payouts">
            <FixedPayoutModalAdminScreen />
          </Modal>
        ),
      },
    ],
  },
  {
    path: "favorites",
    element: <FavouritesAdminScreen />,
    children: [
      {
        path: "new",
        element: (
          <Modal navigatePath="/admin/favorites/:favoriteId">
            <NewFavoriteSliderMenuAdminScreen />
          </Modal>
        ),
      },
    ],
  },
  {
    path: "favorites/:favoriteId",
    element: <FavouriteGroupAdminScreen />,
    children: [
      {
        path: "stats",
        element: (
          <Slider navigatePath="/admin/favorites/:favoriteId">
            <StatsSliderMenuAdminScreen />
          </Slider>
        ),
      },
      {
        path: "social/:userId",
        element: (
          <Slider navigatePath="/admin/favorites/:favoriteId">
            <SocialsSliderMenuAdminScreen />
          </Slider>
        ),
      },
      {
        path: "import",
        element: (
          <Modal navigatePath="/admin/favorites/:favoriteId">
            <ImportCsvModalAdminScreen />
          </Modal>
        ),
      },
      {
        path: "csv/:csvId",
        element: (
          <Slider navigatePath="/admin/favorites/:favoriteId">
            <CsvSliderMenuAdminScreen />
          </Slider>
        ),
      },
    ],
  },
  {
    path: "profile",
    element: <DashboardProfileCommonScreen />,
  },
  {
    path: "communication",
    element: <CommunicationAdminScreen />,
    children: [
      {
        path: "new",
        element: (
          <Slider
            className="px-0 w-full max-w-xl"
            navigatePath="/admin/communication"
          >
            <NewCommunicationSliderMenuAdminScreen />
          </Slider>
        ),
      },
    ],
  },
  {
    path: "wallets/transactions",
    element: <WalletTransactionsBaseAdminScreen />,
    children: [
      {
        path: ":tab",
        element: <WalletTransactionsDataAdminScreen />,
        children: [
          {
            path: ":transactionId",
            element: (
              <Slider className="p-0" navigatePath="/admin/wallets/transactions/:tab">
                <WalletTransactionDetailsSliderAdminScreen />
              </Slider>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "carousels",
    element: <CarouselsAdminScreen />,
  },
  {
    path: "carousels/new",
    element: <CreateCarouselItemAdminScreen />,
  },
  {
    path: "carousels/:id/edit",
    element: <EditCarouselItemAdminScreen />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
